import moment from 'moment';
import { formatDatesOnPayload, formatDatesOnResponse } from 'packages/common/utils/format';
import cepService from 'packages/common/services/cepService';

import selfEmployedResources from '../resource';

const dateFields = ['dateOfBirth', 'admissionDate'];

export function getSelfEmployedList(params) {
  return selfEmployedResources.getSelfEmployedList(params).then(response => response.data);
}

export function getSelfEmployed(id) {
  return selfEmployedResources.getSelfEmployed(id)
    .then(response => formatDatesOnResponse(response.data, dateFields));
}

export function createNewSelfEmployed(selfEmployed) {
  const params = getParamFormattedToPayload(selfEmployed);
  return selfEmployedResources.createNewSelfEmployed(params);
}

export function editSelfEmployed(id, selfEmployed) {
  const params = getParamFormattedToPayload(selfEmployed);
  return selfEmployedResources.editSelfEmployed(id, params);
}

export function deleteSelfEmployed(id) {
  return selfEmployedResources.deleteSelfEmployed(id);
}

export function getJobDescriptions() {
  return selfEmployedResources.getJobDescriptions().then(response => response.data);
}

export function formatDate(date, format) {
  return (date == null) ? null : moment(date).format(format);
}

function getParamFormattedToPayload(selfEmployed) {
  return formatDatesOnPayload(selfEmployed, dateFields);
}

export function getCepInformation(cep) {
  return cepService.getCepInformation(cep);
}
